import Chips from 'components/_UI/Chips'
import Paginate from 'components/_UI/Paginate'
import Table from 'components/_UI/Table'
import Text from 'components/_UI/Text'
import React from 'react'
import { ArrowDownCircle } from 'react-feather'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import colors from 'theme/colors'

export default function WithdrawList({ data, perPage, totalItems, onPaginate, lastPage, currentPage }) {

    const widthDrawData = data?.data?.data?.map(item => {
        const date = new Date(item.created_at);
        return {
            id: `${item.id}`,
            date: `${date.toLocaleDateString('pt-BR')} - ${date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`,
            value: `R$ ${parseFloat(item.value).toFixed(2).replace('.', ',')}`,
            status: <Chips text={item?.status} />,
        };
    });

    return (
        <Container>
            <SectionHeader>
                <SectionIcon>
                    <ArrowDownCircle size={18} color={colors.occasionalPurple} />
                </SectionIcon>
                <HeaderContent>
                    <Text type='bold' color={colors.nightDark} paddingBottom={0}>
                        Histórico de saques
                    </Text>
                    <Text name='small' color={colors.night} paddingBottom={0}>
                        Acompanhe seus saques realizados
                    </Text>
                </HeaderContent>
            </SectionHeader>

            <Table
                rows={widthDrawData}
                columns={['ID', 'Data', 'Valor', 'Status']}
            />

            {lastPage > 1 && (
                <Paginate
                    perPage={perPage}
                    onPaginate={onPaginate}
                    totalItems={totalItems}
                    lastPage={lastPage}
                    firstPage={1}
                    currentPage={currentPage}
                    marginTop={'30px'}
                />
            )}
        </Container>
    );
}

const Container = styled(Column)`
    background: ${colors.neutralLight};
    border: 1px solid ${colors.neutralDark};
    border-radius: 12px;
    padding: 20px;
    margin-top: 10px;
`;

const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
`;

const SectionIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #F3EAFF;
    flex-shrink: 0;
`;

const HeaderContent = styled.div`
    flex: 1;
`;
